import * as React from 'react';
import { SVGProps } from 'react';

const SvgCheckmarkThickOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.56 5.94a1.5 1.5 0 0 1 0 2.12L9.5 19.122l-6.06-6.06a1.5 1.5 0 0 1 2.12-2.122l3.94 3.94 8.94-8.94a1.5 1.5 0 0 1 2.12 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCheckmarkThickOutlined;
